/*!
 * Girlbasket Theme v1.0.0
 * Copyright (c) 2026 Om. All rights reserved.
 *
 * This file is part of the Girlbasket theme, licensed only for use on the
 * Girlbasket store (girlbasket.myshopify.com / girlbasket.com). Copying,
 * modifying, redistributing or reselling this file, in whole or in part,
 * without written permission from Om is prohibited. See LICENSE.md.
 *
 * File: assets/gb-custom.js
 */
/*
  Custom JavaScript for small store-specific changes.
  This file loads after the theme scripts. The theme's tools are on window.GB:
    GB.events.on('cart:updated', ({ cart }) => { ... });
    GB.events.on('drawer:open', ({ id }) => { ... });
*/
